import { render, staticRenderFns } from "./input-weight-progression-table.vue?vue&type=template&id=fab83106&scoped=true&lang=pug"
import script from "./input-weight-progression-table.js?vue&type=script&lang=js&external"
export * from "./input-weight-progression-table.js?vue&type=script&lang=js&external"
import style0 from "./input-weight-progression-table.vue?vue&type=style&index=0&id=fab83106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab83106",
  null
  
)

export default component.exports